import React, { useEffect, useCallback, useMemo } from "react";
import CardTable from "components/CardTable/CardTable";
import { useOpenComponent } from "hooks/useOpenComponent";

import { useDispatch, useSelector } from "react-redux";

import AddIcon from "@mui/icons-material/Add";
import { columns } from "./columns";

import RegularButton from "components/CustomButtons/Button";
import { TableInputs } from "components/CardTable/TableInputs";
import { Home } from "@mui/icons-material";
import { useSearch } from "hooks/useSearch";
import { ModalV2 } from "components/Modal/ModalV2";

import { COLLECT_PERIODS_PHRASE } from "./config";

import { CollectPeriodsForm } from "./CollectPeriodsForm";
import {
  fetchCollectPeriods,
  newCollectPeriod,
  clearCollectPeriods,
  handleCollectPeriodsInputsAction,
} from "redux/actions/buildings/collectPeriods/collectPeriodsActions";

const LOADINGS = [
  "fetchCollectPeriods",
  "fetchNewCollectPeriod",
  "fetchEditCollectPeriod",
];

export const CollectPeriodsPage = () => {
  const dispatch = useDispatch();
  const { isOpen, handleIsOpen } = useOpenComponent();

  const { setSnackbar, clearSearch, buildCompLoadings } = useSearch();
  const { stationsList } = useSelector(state => state.companies);
  const { isLoadingComp } = useSelector(state => state.search);
  const { collectPeriods, station, isAddMode, deleteMode, } = useSelector(state => state.collectPeriods);

  const getCollectPeriods = useCallback(
    stationID => {
      dispatch(fetchCollectPeriods(stationID));
    },
    [dispatch]
  );

  const collectPeriodsMemo = useMemo(
    () =>
      collectPeriods.map(collectPeriod => {
        const newStation = stationsList?.find(
          station => station.id === collectPeriod.idStation
        );

        return {
          ...collectPeriod,
          station: newStation.name,
          modal: handleIsOpen
        };
      }),
    [collectPeriods]
  );

  const handleSubmit = useCallback(() => {
    if (station.length < 1) {
      setSnackbar(COLLECT_PERIODS_PHRASE.search.messages.noStations);
      return;
    }
    const stationID = station.id;
    getCollectPeriods(stationID);
  }, [station, setSnackbar]);

  const submitMemoized = useCallback((e) => {
    e.preventDefault();
    handleSubmit();
  }, [handleSubmit]);

  const handleClose = () => {
    handleIsOpen();
  };

  const handleOpenAdd = () => {
    dispatch(newCollectPeriod());
    handleIsOpen();
  };

  useEffect(() => {
    buildCompLoadings(LOADINGS);
  }, []);

  useEffect(() => {
    clearSearch();
    dispatch(clearCollectPeriods());
  }, [clearSearch]);

  return (
    <React.Fragment>
      <CardTable
        data={collectPeriodsMemo}
        columns={columns}
        loading={isLoadingComp.fetchCollectPeriods}
        title={COLLECT_PERIODS_PHRASE.page.table.title}
        icon={<Home />}
        hasHeader
        blockBtn
        hasControl
        controls={
          <RegularButton
            size="sm"
            round
            justIcon
            color="info"
            style={{ margin: 10 }}
            onClick={handleOpenAdd}
          >
            <AddIcon style={{ margin: 0 }} />
          </RegularButton>
        }
        tableContent={
          <TableInputs
            reducer="collectPeriods"
            stations
            dispatchAction={handleCollectPeriodsInputsAction}
            submitAction={submitMemoized}
          />
        }
      />
      <ModalV2
        open={isOpen}
        onClose={handleClose}
        toRight
        title={isAddMode
          ? COLLECT_PERIODS_PHRASE.modal.titles.add
          : deleteMode
            ? COLLECT_PERIODS_PHRASE.modal.titles.delete
            : COLLECT_PERIODS_PHRASE.modal.titles.edit}
      >
        {
          <CollectPeriodsForm
            handleClose={handleClose}
            stationSelected={station}
          />
        }
      </ModalV2>
    </React.Fragment>
  );
};
